import { Box, colors, makeStyles, MenuItem, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  group: {
    fontWeight: "bolder",
    paddingLeft: theme.spacing(2),
    padding: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
    color: `${colors.common.white} !important`,
    top: -10,
    position: "sticky",
  }
}))

const CustomDropdown = (props) => {
  const {
    labelTitle,
    values,
    changeHandler,
    style,
    errorHandler,
    formData,
    name,
    disabled,
    searchable = false,
  } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  useEffect(() => {
    if (formData.kit) {
      // if (name === "kit") {
      //   if (values[formData.kit].price_class !== "single_gene") {
      //     changeHandler({
      //       target: {
      //         name: "single_gene",
      //         value: "probe",
      //       }
      //     })
      //   } else {
      //     changeHandler({
      //       target: {
      //         name: "single_gene",
      //         value: "pcr",
      //       }
      //     })
      //   }
      // }
    }
  }, [formData.kit])

  if (!searchable) {
    return (
      <TextField
        id={`select-${labelTitle.toLowerCase()}`}
        select
        name={name}
        value={formData && formData[name] ? formData[name] : ""}
        onChange={changeHandler}
        label={labelTitle}
        variant={"outlined"}
        style={style ?? {}}
        radioGroup=""
        required
        error={errorHandler ? errorHandler[name] : false}
        disabled={disabled}
      >
        {Object.entries(values).map((item, index) => {
          return (
            <MenuItem
              disabled={item[0] === "single_end"}
              value={item[0]}
              data-testid={`select-${labelTitle.toLowerCase()}-${item[0]}`}
              key={index}
            >
              {item[1]}
            </MenuItem>
          );
        })}
      </TextField>
    );
  }
  let options;
  if (name === "kit") {
    options = Object.entries(values).map(([key, value]) => ({
      value: key,
      label: value.label,
      price_class: t(value.price_class),
    })).sort((a, b) => a.price_class > b.price_class ? 1 : -1)
  } else {
    options = Object.entries(values).map(([value, label]) => ({
      value,
      label,
    }));
  }

  const selectedOption = options.find(
    (option) => option.value === (formData && formData[name])
  );
  const handleChange = (event, newValue) => {
    changeHandler({
      target: {
        name: name,
        value: newValue ? newValue.value : "",
      },
    });
  };

  return (
    <Autocomplete
      id={`select-${labelTitle.toLowerCase()}`}
      options={options}
      getOptionLabel={(option) => option.label}
      value={selectedOption || null}
      onChange={handleChange}
      disabled={disabled}
      renderGroup={option => [<Box className={classes.group}>{option.group}</Box>, option.children]}
      groupBy={option => {
        return option.price_class
      }}
      style={{ display: "inline-block", minWidth: "200px", marginRight: "10px" }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={labelTitle}
          variant="outlined"
          required
          error={errorHandler ? errorHandler[name] : false}
          style={{ ...style, minWidth: "200px" }}
        />
      )}
      getOptionDisabled={(option) => option.value === "single_end"}
    />
  );
};

export default CustomDropdown;
